<template>
  <div class="login-wraper w-full h-full flex align-center justify-center lg:col-6 md:col-12">
    <v-progress-circular
      :size="70"
      :width="7"
      indeterminate
    />
  </div>
</template>
<script>
// @flow
import { mapActions } from 'vuex';

export default {
  name: 'SSO',
  methods: {
    ...mapActions({
      login: 'auth/login',
      verifyAccess: 'auth/verifyAccess'
    }),
    tryLogin(hash: string) {
      this.login({ hash })
        .then(() => {
          this.verifyAccess()
            .then(() => {
              this.$router.push({ name: 'Dashboard' });
            });
        })
        .catch(() => {
          this.$router.push({ name: 'Login' });
        });
    }
  },
  computed: {
    hash() {
      return this.$route.params.hash;
    }
  },
  mounted() {
    this.tryLogin(this.hash);
  }
};
</script>
